<template>
  <div class="login-floater" v-show="!isLogin">
    <!--    <div class="inner_center">-->
    <div class="login-box">
      <i class="iconfont icon-logo"></i>
      <div class="desc">— 登录即享免费下载超高清图片 —</div>

      <div class="login-ways">
        <div class="login-way-item" @click="loginByQQ(2)">
          <i class="iconfont icon-QQ2"></i>
          <span class="name">QQ登录</span>
        </div>
        <div class="login-way-item">
          <i class="iconfont icon-wechat2" @click="login(1)"></i>
          <span class="name">微信登录</span>
        </div>
        <div class="login-way-item">
          <i class="iconfont icon-mobile" @click="login(0)"></i>
          <span class="name">手机登录</span>
        </div>
      </div>
      <!--      </div>-->
    </div>
  </div>
</template>

<script>
import {fnLogin} from "@/fn";
import {mapState} from "vuex";

export default {
  name: "LoginFloater",
  computed: {
    ...mapState('user', [
      'isLogin'
    ])
  },
  methods: {
    login(index) {
      this.$store.commit('user/SET_LOGIN_WAY', index)
      fnLogin.loginIntercept(false);
    },
    loginByQQ() {
      fnLogin.loginByQQ(this.$store);
    }
  }
}
</script>

<style lang="scss" scoped>
.login-floater {
  //position: fixed;
  top: 270px;
  //left: 0;
  left: 50%;
  transform: translateX(-50%);

  .inner_center {
    //padding-left: 250px;
    box-sizing: border-box;


  }

  .login-box {
    width: 408px;
    height: 260px;
    background: #FFFFFF;
    box-shadow: 0px 12px 24px 0px rgba(0, 0, 0, 0.06), 0px 0px 12px 0px rgba(0, 0, 0, 0.08);
    border-radius: 14px;
    @include LayoutFlex(2);

    .icon-logo {
      font-size: 24px;
      margin-bottom: 10px;
    }

    .desc {
      font-size: 14px;
      color: #596088;
      line-height: 19px;
      margin-bottom: 28px;
    }

    .login-ways {
      @include LayoutFlex(1);

      .login-way-item {
        @include LayoutFlex(2);
        margin-right: 40px;

        &:last-child {
          margin-right: 0;
        }

        .iconfont {
          width: 72px;
          height: 72px;
          border-radius: 50%;
          @include LayoutFlex(1);
          margin-bottom: 12px;
          font-size: 36px;

          &.icon-QQ2 {
            background: rgba(6, 180, 253, 0.12);
            color: rgba(6, 180, 253, 1);
            @include ElementHover('', rgba(6, 180, 253, 0.2))
          }

          &.icon-wechat2 {
            background: rgba(81, 207, 80, 0.12);
            color: rgba(81, 207, 80, 1);
            @include ElementHover('', rgba(81, 207, 80, 0.2))
          }

          &.icon-mobile {
            background: rgba(105, 105, 255, 0.12);;
            color: rgba(105, 105, 255, 1);
            @include ElementHover('', rgba(105, 105, 255, 0.2))
          }
        }

        .name {
          font-size: 14px;
          color: #2D2B33;
          line-height: 19px;
        }
      }
    }
  }
}
</style>
